module.exports = __webpack_public_path__ + "img/logo.e1e9cb6b.svg";